<template>
    <div class="yt-home">
        <h-nav :commonwealData="navData"></h-nav>
        <div class="home-swiper">
            <!-- 轮播 -->
            <h-swiper ref="mySwiper"></h-swiper>
            <ul class="swiper-culture">
                <li :class="{'swiper-active': swiperInx === index}" v-for="(obj, index) in swiperData" :key="obj.id" @click="handleSlideChange(index)">
                    <label>{{obj.title}}</label>
                    <p>{{obj.name}}</p>
                </li>
            </ul>
        </div>
        <!--公益数据-->
        <div class="publicBox">
            <div class="publicData">
                <div class="data-container">
                    <div class="intro-title">
                        <h3>公益数据公开</h3>
                        <div class="title-explain">
                            <div class="title-exp"></div>
                            <span>PUBLIC DATA DISCLOSURE</span>
                            <div class="title-exp"></div>
                        </div>
                        <p class="data-time">2016年10月-至今</p>
                    </div>
                    <ul class="dataList">
                        <li>
                            <p class="item-title">捐赠数据</p>
                            <p class="item-detail" v-for="(item,index) in reportData.donate" :key="index">
                                <span>{{ item.reportName }}</span>
                                <!-- <span>{{ item.reportValue }}</span> -->
                                <countTo :startVal='Number(item.startVal)' :endVal='Number(item.endVal)' :duration='5000' :decimals="item.digitNum"></countTo>
                            </p>
                        </li>
                        <li>
                            <p class="item-title">志愿者数据</p>
                            <p class="item-detail" v-for="(item,index) in reportData.volun" :key="index">
                                <span>{{ item.reportName }}</span>
                                <countTo :startVal='Number(item.startVal)' :endVal='Number(item.endVal)' :duration='5000'></countTo>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mapBox">
                <div class="help-container">
                    <div class="helpArea">
                        <p class="item-title">受助区域</p>
                        <p class="item-detail" v-for="(item,index) in reportData.help" :key="index">
                            <span>{{ item.reportName }}</span>
                            <countTo :startVal='Number(item.startVal)' :endVal='Number(item.endVal)' :duration='5000'></countTo>
                        </p>
                    </div>
                    <h-map ref="myMap" :provinces="provinces"></h-map>
                </div>
            </div>
        </div>

        <!-- 基金会二维码 -->
        <h-code></h-code>
        <!-- 返回顶部 -->
        <h-back-to-top></h-back-to-top>
        <h-footer :commonwealData="navData"></h-footer>
    </div>
</template>
<script>
import countTo from 'vue-count-to';
import { mapState, mapActions } from 'vuex';
import hNav from '../../components/h-nav';
import hSwiper from './components/home-swiper';
import hMap from './components/home-map';
import hCode from '../../components/h-code';
import hBackToTop from '../../components/h-back-to-top';
import hFooter from '../../components/h-footer';

export default {
    name: 'Home',
    data() {
        return {
            startVal: 0,
            endVal: 2017,
            navData: [],
            swiperData: [{
                id: 0,
                title: '使命',
                name: 'MISSION'
            }, {
                id: 1,
                title: '愿景',
                name: 'VISION'
            }, {
                id: 2,
                title: '价值观',
                name: 'VALUES'
            }],
            reportData: {},
            provinces: [
                { name: '北京', value: 9, areaArr: '北京市' },
                { name: '上海', value: 9, areaArr: '上海市' },
                { name: '湖南', value: 12, areaArr: '益阳市、常德市' },
                { name: '江西', value: 13, areaArr: '宜春市、吉安市、赣州市' },
                { name: '福建', value: 17, areaArr: '宁德市、南平市、福州市、三明市、泉州市、漳州市、龙岩市' },
                { name: '辽宁', value: 11, areaArr: '大连市' },
                { name: '青海', value: 13, areaArr: '西宁市、果洛藏族自治州、玉树藏族自治州' },
                { name: '云南', value: 13, areaArr: '德宏傣族景颇族自治州、大理白族自治州、昭通市' },
                { name: '湖北', value: 11, areaArr: '武汉市' },
                { name: '陕西', value: 11, areaArr: '咸阳市' },
                { name: '四川', value: 11, areaArr: '乐山市' },
                { name: '河南', value: 11, areaArr: '驻马店市' },
                { name: '甘肃', value: 11, areaArr: '西定市' },
                { name: '山东', value: 11, areaArr: '聊城市' }
            ]
        };
    },
    components: {
        countTo,
        hNav,
        hSwiper,
        hMap,
        hCode,
        hBackToTop,
        hFooter
    },
    computed: {
        ...mapState('home', {
            swiperIndex: state => state.swiperIndex
        }),
        swiperInx: {
            get() {
                return this.swiperIndex;
            },
            set(nv) {
                return nv;
            }
        }
    },
    methods: {
        ...mapActions('home', [
            'queryCategoryList',
            'queryIndexData'
        ]),
        queryCategoryLists() {
            this.queryCategoryList().then((res) => {
                if (res && res.code === 0) {
                    this.navData = res.data;
                }
            });
        },
        handleSlideChange(inx) {
            this.$store.commit('home/SET_SWIPER_INDEX', inx);
            this.$refs.mySwiper.slideChangeHandle(inx);
        },
        queryIndexDatas() {
            this.queryIndexData().then((res) => {
                if (res && res.code === 0) {
                    this.reportData = res.data;// donate volun help
                    if (this.reportData.donate.length !== 0) {
                        this.reportData.donate.forEach((item) => {
                            if (item.reportValue.match(/^\+?[0-9][0-9]*$/)) {
                                item.digitNum = 0;
                            } else {
                                item.digitNum = 2;
                            }
                            item.startVal = (item.reportValue) > 10000 ? (item.reportValue - 10000) : 0;
                            item.endVal = item.reportValue;
                        });
                    }
                    if (this.reportData.volun.length !== 0) {
                        this.reportData.volun.forEach((item) => {
                            item.startVal = (item.reportValue) > 10000 ? (item.reportValue - 10000) : 0;
                            item.endVal = item.reportValue;
                        });
                    }
                    if (this.reportData.help.length !== 0) {
                        this.reportData.help.forEach((item) => {
                            item.startVal = (item.reportValue) > 10000 ? (item.reportValue - 10000) : 0;
                            item.endVal = item.reportValue;
                        });
                    }
                }
            }, (err) => {
                console.log(err);
            });
        }
    },
    created() {
        this.queryCategoryLists();
        this.queryIndexDatas();
    }
};
</script>
<style lang="scss" scoped>
@import '../../common/css/common.scss';

.yt-home {
    width: 100%;
    min-width: 1180px;
}
.home-swiper {
    position: relative;
    // padding-top: 88px;
    min-height: 600px;
    background: rgba(16, 25, 30, 0.08);
    .swiper-culture {
        position: absolute;
        right: 272px;
        top: 54%;
        transform: translateY(-48%);
        width: 320px;
        text-align: left;
        border-bottom: none;
        background: transparent;
        z-index: 2;
        >li {
            margin-top: -2px;
            border: 2px solid rgba(255, 255, 255, 0.4);
            width: 100%;
            padding: 55px 0;
            color: #FFFFFF;
            text-indent: 40px;
            label {
                font-size: 28px;
            }
            p {
                font-size: 18px;
            }
        }
        &:first-child{
            margin-top: 0;
        }
        li.swiper-active {
            border: 2px solid rgba(255, 255, 255, 1);
        }
    }
}
.publicBox{
   width: 100%;
   background: #F7F9FC;
   padding-bottom: 64px;
}
.publicData{
    .data-container{
        margin: 0 auto;
        width: 1180px;
        .intro-title {
            padding: 64px 0;
            font-size: 16px;
            color: #8F9BB3;
            h3{
                padding-bottom: 4px;
                font-weight: 600;
                font-size: 28px;
                color: #222B45;
                line-height: 40px;
            }
            .title-explain {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                > span {
                    margin: 0 20px;
                }
            }
            .title-exp {
                width: 100px;
                height: 1px;
                background-color: #E4E9F2;
            }
        }
        .dataList{
            width: 100%;
            li{
                height: 180px;
                background: #FFFFFF;
                box-shadow: inset 0px -1px 0px 0px #EDF1F7;

            }
        }
    }
}

.item-title{
    margin-left: 40px;
    float: left;
    width: 212px;
    line-height: 180px;
    font-size: 28px;
    font-weight: 600;
    color: #222B45;
    text-align: left;
}
.item-detail{
    float: left;
    height: 180px;
    width: 309px;
    text-align: left;
    span:nth-child(1){
        display: inline-block;
        width: 100%;
        font-size: 16px;
        color: #222B45;
        line-height: 22px;
        padding-top: 52px;
    }
    span:nth-child(2){
        display: inline-block;
        font-size: 40px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #EB6100;
        line-height: 47px;
        padding-top: 8px;
    }
}

.mapBox{
    width: 100%;
    height: 813px;
    position: relative;
    margin-top: 32px;
    .help-container{
        margin: 0 auto;
        width: 1180px;
        height: 813px;
        background: #fff;
    }
}

.data-time{
        font-size: 20px;
        font-weight: 600;
        color: #222B45;
        line-height: 28px;
        text-align: center;
        width: 100%;
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue